// Флаг, который указывает - инициализирован ли на странице скрипт для
// взаимодействия с Facebook API
var loaded = false; // Инициализирует интерфейс для взаимодействия с Facebook API, после инициализации
// взаимодействие осуществляется через глобальный объект `window.FB`

export default (function (_ref) {
  var appId = _ref.appId,
      _ref$autoLogAppEvents = _ref.autoLogAppEvents,
      autoLogAppEvents = _ref$autoLogAppEvents === void 0 ? false : _ref$autoLogAppEvents,
      _ref$xfbml = _ref.xfbml,
      xfbml = _ref$xfbml === void 0 ? false : _ref$xfbml,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? 'v5.0' : _ref$version;

  if (loaded) {
    return;
  }

  loaded = true;
  var initInterval = setInterval(function () {
    if (window.FB) {
      clearInterval(initInterval);
      window.FB.init({
        appId: appId,
        autoLogAppEvents: autoLogAppEvents,
        xfbml: xfbml,
        version: version
      });
    }
  }, 100);
});